import { ITotal } from '~shared/modules/cart/models';
import { GaTrackingCheckoutService } from '~shared/modules/ga-tracking/utils/ga-tracking-checkout.service';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { ApplicationEventType } from '../constants';
import { ApplicationEvent } from './application-event.model';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export class CheckoutAddPaymentInfoApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.AddPaymentInfo;

  constructor(
    private cartOfferLines: CartOfferLine[],
    private total: ITotal,
    private discountCode: string,
    private priceType: string,
  ) {}

  getPayload(): any {
    const shipping = this.priceType === PriceTypes.b2b ? this.total?.netShippingCostTotal : this.total?.shippingCostTotal;

    return {
      currency: 'EUR',
      coupon: this.discountCode,
      value: this.total?.total ? +this.total.total : null,
      ...GaTrackingCheckoutService.getAuthorizeFlow,
      price_type: this.priceType,
      ecommerce: {
        items: GaTrackingCheckoutService.getItemsForApplicationEvent(this.cartOfferLines),
        shipping,
      },
    };
  }
}
